import { Grid, IconButton, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import { FaCheck, FaRegCopy } from "react-icons/fa6"
import { copyToClipboard } from "../../../../../../../components/copy"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { LineComponent } from "../../../../../../../components/line"
import { Timer } from "../../../../../../../components/timer"
import useAuth from "../../../../../../../context/auth"

interface Props {
    open: boolean,
    onClose: () => void,
    code: string,
    withoutModal?: boolean
}

export const ModalPayDaily = ({
    onClose,
    open,
    code,
    withoutModal
}: Props) => {
    const { handleModal } = useAuth()
    const [copied, setCopied] = useState(false)

    const copy = async () => {
        const success = await copyToClipboard(code)

        if (success) {
            setCopied(true)
            handleModal(true, {
                message:
                    <>
                        <Typography>Link copiado com sucesso</Typography>
                        <Typography fontSize={"1.4rem"} mt={"1rem"} fontWeight={400} color="black !important">Agora abra o aplicativo do seu banco na área PIX</Typography>
                    </>,
                type: "success"
            })
        } else {
            handleModal(true, {
                message: "Erro ao copiar código",
                type: "error"
            })
        }
    }

    useEffect(() => {
        if (copied) {
            setTimeout(() => {
                setCopied(false)
            }, 3000);
        }
    }, [copied])

    if (withoutModal && open) {
        return (
            <>
                <Typography fontSize={"1.4rem"} sx={{ opacity: .5 }} mt={"2rem"}>Para efetuar o pagamento, copie o código PIX abaixo e cole no aplicativo do seu banco</Typography>
                <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>1° PASSO</Typography>
                <Typography fontSize={"1.4rem"} fontWeight={400}>Clique no código PIX abaixo para copiar</Typography>

                <Grid
                    display={"flex"}
                    direction={"row"}
                    boxSizing={"border-box"}
                    gap={"1rem"}
                    ml={"1rem"}
                    mt={"1rem"}
                >

                    <Grid
                        onClick={copy}
                        sx={{
                            height: "4.9rem",
                            width: "calc(100% - 4.9rem - 2rem)",
                            border: "1px solid black",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            overflow: "hidden",
                            pl: ".8rem",
                        }}>
                        <Typography
                            fontSize={"1.4rem"}
                            fontWeight={600}
                            lineHeight={"1.694rem"}
                            width={"100%"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                        >
                            {code}
                        </Typography>
                    </Grid>

                    <IconButton
                        onClick={copy}
                        sx={{
                            height: "4.9rem",
                            width: "4.9rem",
                            border: "1px solid black",
                            borderRadius: "10px",
                            animation: "pulse 1.5s infinite"
                        }}
                    >
                        {!copied ? <FaRegCopy size={20} color="#000000" /> : <FaCheck size={20} color="green" />}
                    </IconButton>
                </Grid>

                <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

                <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>2° PASSO</Typography>
                <Typography fontSize={"1.4rem"} fontWeight={400}>Abra o aplicativo do seu banco na área PIX</Typography>
                <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

                <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>3° PASSO</Typography>
                <Typography fontSize={"1.4rem"} fontWeight={400}>Cole o código na área PIX Copia e Cola</Typography>
                <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

                <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>4° PASSO</Typography>
                <Typography fontSize={"1.4rem"} fontWeight={400}>Efetue o pagamento</Typography>

                <Typography m={"1rem 0rem"} fontSize={"1.2rem"} sx={{ opacity: .5 }} textAlign={"center"} fontStyle={"italic"}><strong>Obs:</strong> Ao efetuar o pagamento, identificamos e baixamos automaticamente, não é necessário que nos envie o comprovante de pagamento.</Typography>

                <Grid
                    width={"100%"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    mt={2}
                >
                    <Grid
                        sx={{
                            backgroundColor: "#D9D9D940",
                            borderRadius: "10px",
                            minHeight: "7rem",
                            width: "22.11rem",

                            padding: ".7rem"
                        }}
                    >
                        <Typography textAlign={"center"} fontSize={"1.4rem"}>O código acima expira em:</Typography>
                        <Typography textAlign={"center"} fontWeight={700} fontSize={"2rem"}>
                            <Timer
                                hours={60 * 30}
                            />
                        </Typography>
                    </Grid>
                </Grid>
            </>
        )
    }


    return (
        <ModalComponent
            open={open}
            onClose={onClose}
            title="Pagar diárias"
            description="Para efetuar o pagamento, copie o código PIX abaixo e cole no aplicativo do seu banco"
            titleProps={{
                fontSize: "2rem",
                fontWeight: 700
            }}

        >
            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>1° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Clique no código PIX abaixo para copiar</Typography>

            <Grid
                display={"flex"}
                direction={"row"}
                boxSizing={"border-box"}
                gap={"1rem"}
                ml={"1rem"}
                mt={"1rem"}
            >

                <Grid
                    onClick={copy}
                    sx={{
                        height: "4.9rem",
                        width: "calc(100% - 4.9rem - 2rem)",
                        border: "1px solid black",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                        pl: ".8rem",
                    }}>
                    <Typography
                        fontSize={"1.4rem"}
                        fontWeight={600}
                        lineHeight={"1.694rem"}
                        width={"100%"}
                        whiteSpace={"nowrap"}
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                    >
                        {code}
                    </Typography>
                </Grid>

                <IconButton
                    onClick={copy}
                    sx={{
                        height: "4.9rem",
                        width: "4.9rem",
                        border: "1px solid black",
                        borderRadius: "10px",
                        animation: "pulse 1.5s infinite"
                    }}
                >
                    {!copied ? <FaRegCopy size={20} color="#000000" /> : <FaCheck size={20} color="green" />}
                </IconButton>
            </Grid>

            <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>2° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Abra o aplicativo do seu banco na área PIX</Typography>
            <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>3° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Cole o código na área PIX Copia e Cola</Typography>
            <LineComponent expansive={false} usedInModal height=".5px" color="#00000080" margin="2rem 0rem" />

            <Typography color="primary" fontSize={"1.4rem"} fontWeight={700} mb={.5}>4° PASSO</Typography>
            <Typography fontSize={"1.4rem"} fontWeight={400}>Efetue o pagamento</Typography>

            <Typography m={"1rem 0rem"} fontSize={"1.2rem"} sx={{ opacity: .5 }} textAlign={"center"} fontStyle={"italic"}><strong>Obs:</strong> Ao efetuar o pagamento, identificamos e baixamos automaticamente, não é necessário que nos envie o comprovante de pagamento.</Typography>

            <Grid
                width={"100%"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                mt={2}
            >
                <Grid
                    sx={{
                        backgroundColor: "#D9D9D940",
                        borderRadius: "10px",
                        minHeight: "7rem",
                        width: "22.11rem",

                        padding: ".7rem"
                    }}
                >
                    <Typography textAlign={"center"} fontSize={"1.4rem"}>O código acima expira em:</Typography>
                    <Typography textAlign={"center"} fontWeight={700} fontSize={"2rem"}>
                        <Timer
                            hours={60 * 30}
                        />
                    </Typography>
                </Grid>
            </Grid>

        </ModalComponent>
    )
}